import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { PublicPaymentService } from '../services/publicPayment.service';
import { SharedService } from '../services/shared.service';
import { Title } from '@angular/platform-browser';
import { Tab_Title } from '../models/lookup-data.model';
import { slideInOut } from 'src/app/application/animations/slideInOut';

@Component({
  selector: 'online-app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  animations: [slideInOut]
})
export class PaymentComponent implements OnInit, OnDestroy {
  paymentForm: FormGroup;
  paymentStatus;
  referenceNoErrorMsg;
  amountErrorMsg; 
  trySubmit = false;
  paymentMethod: string;

  constructor(private router: Router,
    private sharedService: SharedService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private paymentService: PublicPaymentService,
    private titleService: Title) {

    this.titleService.setTitle(Tab_Title.Public_Payment_Title);
    this.sharedService.setHeaderText('Make Payment Online');

    this.renderer.addClass(document.body, 'login-screen');

    this.paymentForm = this.formBuilder.group({
      recaptchaReactive: ['', Validators.compose([Validators.required])],
      referenceNo: ['', Validators.compose([Validators.required])],
      amount: ['', Validators.compose([Validators.required])],      
    });
    
  }

  ngOnInit() {
    this.paymentStatus = this.route.snapshot.paramMap.get("paymentStatus");
    console.log(this.paymentStatus);    

    this.route.queryParams.subscribe(params => {
      this.paymentMethod = params['payment']; 
      console.log(this.paymentMethod);
    });

  }

  makeAnotherPayment() {
    this.router.navigate(['/online-payment']);

  }

  onSubmit(paymentValue){
    this.trySubmit = true;
    this.referenceNoErrorMsg = '';

    this.amountErrorMsg = '';
    console.log(paymentValue);

    this.paymentForm.get('referenceNo').setErrors(null);
    this.paymentForm.get('amount').setErrors(null);
    
    this.paymentForm.updateValueAndValidity();

    if(!paymentValue.referenceNo){
      this.referenceNoErrorMsg = 'Reference No. is required';

      this.paymentForm.get('referenceNo').setErrors({
        required: true
      });
    } else if(!this.validateReferenceNo(paymentValue.referenceNo)){
      this.referenceNoErrorMsg = 'Incorrect reference number';

      this.paymentForm.get('referenceNo').setErrors({
        required: true
      });

    }
    if(!paymentValue.amount){
      this.amountErrorMsg = 'Amount is required';

      this.paymentForm.get('amount').setErrors({
        required: true
      });
    }

    if(paymentValue.amount <= 0){
      this.amountErrorMsg = 'Amount must be bigger than 0';
      
      this.paymentForm.get('amount').setErrors({
        shouldBePositive: true
      });
    }

    this.paymentForm.updateValueAndValidity();

    if (this.paymentForm.invalid) {
      return;
    }

    
    this.paymentService.validatePaymentReferenceNo(paymentValue.referenceNo)
      .subscribe((result: any) => {

        console.log(result);

        if(result.Result){          

          if(result.Result === 'No Application Fee'){
            this.referenceNoErrorMsg = 'Please use the Online Application Portal to proceed with Application Fee payment';

            this.paymentForm.get('referenceNo').setErrors({
              noApplicationFee: true,
              backEndValidation: false,
            });
          }
          else {
            //this.referenceNoErrorMsg = result.Result;
            this.referenceNoErrorMsg = 'Incorrect reference number';

            this.paymentForm.get('referenceNo').setErrors({
              backEndValidation: true,
              noApplicationFee: false,
            });
          }

        } else {

          this.paymentService.getPaymentUri(paymentValue.referenceNo, paymentValue.amount, this.paymentMethod)                      
            .subscribe((result: any) => {

              console.log(result);

              if (!result || !result.Result){
                console.log('server error');
                this.router.navigate(['/server-error']);
              } else {

                window.location.href = result.Result;

                // this.paymentForm.setValue({
                //   referenceNo: null,
                //   amount: null,
                //   recaptchaReactive: null
                // });
                //this.paymentForm.updateValueAndValidity();
                
                
              }                      
            },
            err => {
              console.log(err);
              this.router.navigate(['/server-error']);
            });

        }
      });
    
  }

  ngOnDestroy() {
    this.sharedService.resetHeaderText();
  }

  validateReferenceNo(referenceNo){
    // comment this for trp refrence no
    // if(String(referenceNo).length != 11)
    //   return false;
    
    if(!referenceNo)
      return false;
    
    if(referenceNo.toUpperCase().startsWith('ST'))
      return true;

     if(!/^\d+$/.test(referenceNo))
       return false;
    
    return true;

  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

}
